import type { SelectionUnit } from './invoiceSelection';
import type { InvoiceLinePayload } from '../types/agreements.types';

/** `item` and `add_on` units both become `item` lines, since every add-on
 *  is an `agreement_items` row. */
export function toInvoiceLines(selection: SelectionUnit[]): InvoiceLinePayload[] {
    return selection.map((unit) => {
        if (unit.kind === 'service') {
            return { kind: 'service', agreement_service_id: unit.serviceId };
        }
        if (unit.kind === 'item') {
            return { kind: 'item', agreement_item_id: unit.itemId };
        }
        return { kind: 'item', agreement_item_id: unit.addOnId };
    });
}
